import { OfferDeliveryDates } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';

export const loadOffersDeliveryDates = createAction(
  '[View Offers] Load Product Card Delivery Dates',
  props<{ payload: ReplacementOffer }>()
);
export const addOfferDeliveryDates = createAction(
  '[View Offers] Add Product Card Delivery Dates',
  props<{ payload: OfferDeliveryDates }>()
);
